export function getSalePrice(price, sale) {

    if(!sale)
        return price;

    if(!sale.enabled)
        return price;

    if(sale.discountType==="percentage"){

        return Math.round(

            price *

            (1-sale.discountValue/100)

        );

    }

    return Math.max(

        0,

        price-sale.discountValue

    );

}
